window.addEventListener("DOMContentLoaded", () => {
    const form = document.querySelector('form.contact-form');
    if (form) {
        form.addEventListener('submit', async ev => {
            ev.preventDefault()

            const inputs = form.querySelectorAll('input, textarea, select')
            const submit = form.querySelector('input[type=submit]')

            const data = new FormData(form)

            submit.value = 'Sending...'

            try {
                await fetch(form.action, {
                    method: form.method,
                    body: data,
                    headers: {
                        'Accept': 'application/json'
                    }
                })

                submit.value = "Sent!";
                inputs.forEach(inp => inp.setAttribute('disabled', true));
            } catch(error) {
                submit.value = 'Oops! There was a problem submitting your form'
            }
        })
    }
})
